import React from "react";
import { withTranslation } from "react-i18next";
import { getWindow } from "ssr-window";

import { api } from "@/utils/api";
import { setUrlParameter } from "@/utils";
import ArticleItem from "@/react-components/ArticleItem";
import EmptyResult from "@/react-components/EmptyResult";
import Pagination from "@/react-components/Pagination";
import BackButton from "@/react-components/BackButton";

class LibraryExampleInfoSection extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      pageParams: {
        pageNo: getWindow()?.history?.state?.params?.pageNo || 1,
        pageSize: 10,
        totalPage: 1,
        catagoryID:
          getWindow()?.history?.state?.params?.catagoryID ||
          props?.router?.location?.state?.category?.id,
      },
      // 検索結果の保存
      articles: undefined,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = () => {
    const { pageParams } = this.state;
    const state = getWindow()?.history?.state || {};
    state.params = pageParams;
    getWindow().history.replaceState(state, "");
    api.library
      .getExampleList({
        categoryid: pageParams.catagoryID,
        pageindex: pageParams.pageNo,
        pagesize: pageParams.pageSize,
      })
      .then((response) => {
        pageParams.totalPage = parseInt(
          (response.totalCount + pageParams.pageSize - 1) / pageParams.pageSize
        );
        this.setState({
          pageParams,
          articles: response.list,
        });
        if (response.list.length === 0) {
          setUrlParameter({ type: "noResult" });
        } else {
          setUrlParameter({
            page: pageParams.pageNo,
          });
        }
      })
      .catch((error) => {
        console.error("error: " + error.message);
      });
  };

  pageChange = (page) => {
    const { pageParams } = this.state;
    pageParams.pageNo = page;
    this.setState({ pageParams }, () => {
      this.fetchData();
    });
  };

  render() {
    const {
      articles,
      pageParams: { totalPage, pageNo },
    } = this.state;
    return (
      <section className="library-example-info-section-container">
        <BackButton {...this.props} />
        <h3 className="page-title-text page-title">
          {this.props?.router?.location?.state?.category?.text}
        </h3>
        {articles && (
          <React.Fragment>
            {/* 検索結果 */}
            <div className="section-content">
              {articles.map((item, index) => (
                <ArticleItem key={index} articles={item} />
              ))}
            </div>
            {/* 改ページ */}
            {articles.length > 0 ? (
              <div className="pagination-container">
                <Pagination
                  totalPage={totalPage}
                  pageIndex={pageNo}
                  onChange={this.pageChange}
                />
              </div>
            ) : (
              // 検索結果なし
              <EmptyResult text={this.props.t("TCMS01025_searchResult")} />
            )}
          </React.Fragment>
        )}
      </section>
    );
  }
}

export default withTranslation()(LibraryExampleInfoSection);
